import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedCardComponent } from "./med-card.component";

@NgModule({
  declarations: [
    MedCardComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedCardComponent,
  ],
})
export class MedCardModule { }
